import { Link } from "react-router-dom";
import { agcArticleLink } from "../data/Data";

// Lightbulb — "Boss of my Mind"
const IdeaGraphic = () => (
  <svg viewBox="0 0 240 240" className="page-graphic__svg" role="img" aria-label="A glowing lightbulb">
    <g stroke="#f2b632" strokeWidth="8" strokeLinecap="round">
      <path d="M120 18 L120 38" />
      <path d="M52 46 L66 60" />
      <path d="M188 46 L174 60" />
      <path d="M26 112 L46 112" />
      <path d="M214 112 L194 112" />
    </g>
    <path
      d="M120 58 C86 58 62 84 62 116 C62 138 74 152 86 164 C94 172 96 180 96 190 L144 190 C144 180 146 172 154 164 C166 152 178 138 178 116 C178 84 154 58 120 58 Z"
      fill="#fde58a" stroke="#2d4593" strokeWidth="8" strokeLinejoin="round"
    />
    <path d="M106 150 L120 124 L134 150" fill="none" stroke="#2d4593" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M98 204 L142 204 M104 220 L136 220" stroke="#2d4593" strokeWidth="8" strokeLinecap="round" />
  </svg>
);

export default function AdaptiveGrowth() {
  return (
    <div className="page">
      <h1 className="page-title">Adaptive Growth Culture</h1>

      <div className="page-split">
        <div className="page-split__text">
          <p>
            <strong>Adaptive Growth Culture (AGC) is a modern, step-by-step model</strong> developed
            by Trish Hambridge and her team that{" "}
            <strong>helps people navigate life and thrive after developing aphasia</strong> from a
            stroke or brain injury. By combining <strong>brain science</strong> and{" "}
            <strong>practical wisdom</strong>, the AGC shifts a person with aphasia from a passive
            patient into an <strong>empowered ‘Lead Pathfinder’</strong>. The AGC model unites
            people with aphasia, speech therapists, families, and friends around hope and progress.
            By separating a person’s clear mind from damaged language wiring, AGC offers simple,
            practical tools—like the 4-Step ‘Pivot’ Tool—that{" "}
            <strong>shift communication hurdles into moments of true connection.</strong>
          </p>

          <h2 className="section-title">The AGC Motto:</h2>
          <blockquote className="agc-motto">
            “Aphasia is just static in the machine, but I am the Boss of my Mind. When frustration
            rises, I surf it. When hiccups happen, I pivot. I am the Lead Pathfinder taking the
            reins.”
          </blockquote>

          <p>
            For more information on AGC, you can read Trish Hambridge’s full article,{" "}
            <a href={agcArticleLink} target="_blank" rel="noopener noreferrer" className="text-link">
              <em>Adaptive Growth Culture: A New Blueprint for Life After Aphasia</em>
            </a>
            .
          </p>

          <Link to="/adaptive-growth-culture/reading" className="btn-outline">
            Additional Reading →
          </Link>
        </div>

        <div className="page-split__media page-graphic page-graphic--green">
          <IdeaGraphic />
        </div>
      </div>
    </div>
  );
}
